import React from 'react';

const  PalletTableComponentLoadable = React.lazy(() => import('./PalletTableComponent'));
const  PalletDetailComponentLoadable = React.lazy(() => import('./PalletDetailComponent'));
export {
    PalletDetailComponentLoadable,
    PalletTableComponentLoadable
}